<!--桥梁管理-->
<template>
  <el-row class="hei100 flex-column">
    <el-row id="part1">
      <img class="block wid100" src="@/assets/images/banner.png" alt="">
      <el-row class=" absoluteBtm sysmenu" style="left:190px; right:190px;bottom:-112px">
        <el-row class=" absoluteCont bgc-wt radius-20" type="flex">
          <div class="flex-son text-center pad20 algincenter" v-for="(item,index) in sysmenulist" :key="index">
            <div class="pointer" @click="openSys(index)">
              <div :class="item.icon" class="auto"></div>
              <div class=" height50 pading-top10">
                <span class="ft-size18 fc-2 bold">{{item.name}}</span>
              </div>
            </div>
          </div>
        </el-row>
      </el-row>
    </el-row>
    <!-- part2 -->
    <el-row id="part2" class=" " style="padding-top:160px;">
      <div class=" auto">
        <img class="block auto" src="../../assets/part1/home-part1.png" alt="">
      </div>
      <el-row class="auto" style="width:86%;">
        <el-row>
          <el-col :span="8" @click.native="openSysUrl(1)">
            <img class="block wid100 pointer" src="../../assets/part1/1.png" alt="">
          </el-col>
          <el-col :span="8" @click.native="openSysUrl(2)">
            <img class="block wid100 pointer" src="../../assets/part1/2.png" alt="">
          </el-col>
          <el-col :span="8" @click.native="openSysUrl(3)">
            <img class="block wid100 pointer" src="../../assets/part1/3.png" alt="">
          </el-col>
        </el-row>
        <el-row :gutter="20" style=" padding:0 24px 100px;">
          <el-col :span="6" @click.native="openSysUrl(4)">
            <img class="block wid100 pointer" src="../../assets/part1/4.png" alt="">
          </el-col>
          <el-col :span="6" @click.native="openSysUrl(5)">
            <img class="block wid100 pointer" src="../../assets/part1/5.png" alt="">
          </el-col>
          <el-col :span="6" @click.native="openSysUrl(6)">
            <img class="block wid100 pointer" src="../../assets/part1/6.png" alt="">
          </el-col>
          <el-col :span="6" @click.native="openSysUrl(7)">
            <img class="block wid100 pointer" src="../../assets/part1/7.png" alt="">
          </el-col>
        </el-row>
      </el-row>
      <div class=" absoluteBtm bgc-gray" style="height:40%;right:0;z-index:-1;"></div>
    </el-row>
    <!-- part3 -->
    <el-row id="part3" class=" " style="padding-top:80px;">
      <el-row class="auto" style="width:80%; padding-bottom:50px;">
        <el-col :span="12">
          <div class="hei30 absolute pointer" style="left:24%;top:16%;" @click="openUrlCom()"><span
              class=" fc-blue ft-size18">查看详情&gt;&gt;</span></div>
          <img class="block wid100" src="../../assets/part2/part2.png" alt="">
        </el-col>
        <el-col :span="12" style=" padding-left:40px; padding-top:60px;">
          <video src="@/assets/xckj.mp4" controls width="100%" height="auto">
            您的浏览器不支持 audio 标签。
          </video>
        </el-col>
      </el-row>
      <!-- <div class="">
        <img class="block wid100" src="../../assets/part2/part2-2.png" alt="">
      </div> -->
    </el-row>
    <!-- part4 -->
    <el-row id="part4" class=" " style="padding-top:100px;">
      <div class="">
        <img class="block wid100" src="../../assets/part2/part3.png" alt="">
      </div>
    </el-row>
    <!-- part5 -->
    <el-row id="part5" class=" " style="padding-top:80px;">
      <div class="relative">
        <div class="hei30 absolute pointer" style="left:30%;top:16%;" @click="openUrlnews()"><span
            class=" fc-blue ft-size18">查看全部&gt;&gt;</span></div>
        <img class="block wid100" src="../../assets/part2/part4.png" alt="">
      </div>
    </el-row>
    <!-- part6 -->
    <el-row id="part6" class=" " style="padding-top:120px; padding-bottom:80px;">
      <div class=" height50 text-center"><span class="ft-size24 fc-blue bold">客户及合作伙伴</span></div>
      <el-row class="auto" style="width:86%;">
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner1.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner2.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner3.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner4.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner5.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner6.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner7.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner8.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner9.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner10.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner11.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner12.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner13.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner14.png" alt="">
        </div>
        <div class=" fl wid20 pading-left20 pading-top20">
          <img class="block wid100" src="../../assets/images/partner15.png" alt="">
        </div>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "bridge",
  components: {},
  data() {
    return {
      sysmenulist: [
        { name: "路面养护科学决策系统", icon: "sys01" },
        { name: "路面养护智能管理系统", icon: "sys02" },
        { name: "桥梁养护智能管理系统", icon: "sys03" },
        { name: "智慧工地", icon: "sys04" },
        { name: "路面技术状况检测系统", icon: "sys05" },
        { name: "桥梁定期检测系统", icon: "sys06" }
      ]
    };
  },
  mounted() {},
  methods: {
    // 公司简介
    openUrlCom() {
      this.$router.push({ path: "/company", query: { onindex: 1 } });
    },
    // 新闻
    openUrlnews() {
      document.documentElement.scrollTop = 0;
      this.$router.push({ path: "/newsList", query: { onindex: 1 } });
    },
    // 系统
    openSys(index) {
      let m = 1;
      switch (index) {
        case 0:
          m = 1;
          break;
        case 1:
          m = 2;
          break;
        case 2:
          m = 3;
          break;
        case 3:
          m = 4;
          break;
        case 4:
          m = 7;
          break;
        case 5:
          m = 5;
          break;
      }
      this.$router.push({ path: "/sysinfo", query: { onindex: m } });
    },
    openSysUrl(n) {
      this.$router.push({ path: "/sysinfo", query: { onindex: n } });
    }
    // getMarker(item){
    //   console.log(item);
    //   let params={};
    //   params.id = this.lineInfo.bridge_id;
    //   params.lon = item.Ya;
    //   params.lat = item.Za;
    //   this.$api.api_all.post_bridgeLocation(params).then(res=>{
    //     if(res.data.resultCode=='1'){
    //       this.$message.success('设置位置成功！');
    //     }
    //   })
    // },
  },
  destroyed() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/bridge.vue